import { Box } from '@mui/material'
import { BaseScatola, BaseTitolo, Azienda, Persona } from '@lucan/base-ui'

export default function PassDettagliAnagrafica(props) {
  const { permesso, val, txt } = props
  const { personaOAzienda } = permesso.anagrafica

  const propsComuni = {
    espanso: true,
    bloccaEspansione: true,
    senzaContenitore: true,
    elevation: 0,
    accordionDetailsProps: { sx: { p: 0 } },
    accordionSummaryProps: { sx: { p: 0, mt: -1 } },
  }

  return (
    <BaseScatola>
      <BaseTitolo>Anagrafica</BaseTitolo>
      <Box sx={{ width: '40rem' }}>
        {personaOAzienda.persona &&
          <Persona
            persona={personaOAzienda.persona}
            nascondiCittadinanza
            nascondiDocumento
            nascondiContenutoInvisibile
            propsContatti={{
              propsCoppie: {
                propsCoppia: { sx: { minWidth: 'max-content' } }
              }
            }}
            {...propsComuni}
          />
        }

        {personaOAzienda.azienda &&
          <Azienda
            azienda={personaOAzienda.azienda}
            {...propsComuni}
          />
        }
      </Box>
    </BaseScatola>
  )
}